module.exports = __webpack_public_path__ + "img/118.2.83c242bf.png";